import React from 'react';
import { Redirect } from 'react-router-dom';
import { useMutation, useQueryCache } from 'react-query';
import { motion } from 'framer-motion';

import logo from '../../../assets/images/logo.png';
import { logoutUser } from '../../api/auth';
import useUser from '../../queries/user';

const Navbar = () => {
  const cache = useQueryCache();
  const { user } = useUser();
  const [logUserOut] = useMutation(logoutUser, {
    onSuccess: () => {
      cache.invalidateQueries('user');
      cache.setQueryData('user', undefined);
    },
    onSettled: () => {
      <Redirect to="/login" />;
    },
  });

  const handleLogout = async (e) => {
    e.preventDefault();
    await logUserOut();
  };

  return (
    <nav className="flex justify-between items-center sticky bg-white top-0 z-50 overflow-hidden shadow-md capitalize p-1">
      <img src={logo} className="rounded-md w-40 h-auto p-1" alt="logo" />
      {user && (
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          className="flex items-center"
        >
          <p className="text-lg font-semibold px-2">{user.name}</p>
          <button
            className="btn-primary-sq"
            type="button"
            onClick={handleLogout}
          >
            <svg viewBox="0 0 24 24" className="w-5">
              <path
                fill="#FFFFFF"
                d="M10.79,16.29 L10.79,16.29 C11.18,16.68 11.81,16.68 12.2,16.29 L15.79,12.7 C16.18,12.31 16.18,11.68 15.79,11.29 L12.2,7.7 C11.81,7.31 11.18,7.31 10.79,7.7 L10.79,7.7 C10.4,8.09 10.4,8.72 10.79,9.11 L12.67,11 L4,11 C3.45,11 3,11.45 3,12 L3,12 C3,12.55 3.45,13 4,13 L12.67,13 L10.79,14.88 C10.4,15.27 10.41,15.91 10.79,16.29 Z M19,3 L5,3 C3.89,3 3,3.9 3,5 L3,8 C3,8.55 3.45,9 4,9 L4,9 C4.55,9 5,8.55 5,8 L5,6 C5,5.45 5.45,5 6,5 L18,5 C18.55,5 19,5.45 19,6 L19,18 C19,18.55 18.55,19 18,19 L6,19 C5.45,19 5,18.55 5,18 L5,16 C5,15.45 4.55,15 4,15 L4,15 C3.45,15 3,15.45 3,16 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z"
              />
            </svg>
          </button>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;
